import { lazy } from 'react';

export const WelcomePageLazy = lazy(() => import('./WelcomePage'));
